import type { CardInstance } from "../../domain/types/index.js";

/**
 * discard イベント適用時、ドメインは即座に場を空にする。
 * 飛行アニメーションの発生源を残すため、捨て札ステップでは退場前のカードを表示し続ける。
 */
export function displayedInPlayCards(
  eventKind: string,
  inPlay: readonly CardInstance[],
  lastNonEmptyInPlay: readonly CardInstance[],
): readonly CardInstance[] {
  if (eventKind === "discard" && inPlay.length === 0) return lastNonEmptyInPlay;
  return inPlay;
}
